import { BaseViewModel } from "../system/systemOverview/SystemOverview.types";
import { InternalAssessmentApiModel } from "./InternalAssessments.types";
import { AssigneeType, SelectableAssignee } from "./SelectableAssignee.types";
import { RiskLevel } from "../legalEntity/legalEntityClassificationTab/LegalEntityClassificationTab.types";
import { RelationSaveModel } from "../taskManagement/createTaskPane/CreateTaskPane.types";

export interface InternalAssessmentGroupViewModel {
    rows: Array<InternalAssessmentGroupRow>;
    assigneeFilterOptions: Array<BaseViewModel>;
    sentYearFilterOptions: Array<BaseViewModel>;
}

export interface InternalAssessmentGroupRow {
    id: string;
    name: string;
    description?: string;
    questionnaire: BaseViewModel;
    sent?: Date;
    deadline: Date;
    responsible: BaseViewModel;
    sender?: string;
    senderId?: string;
    totalCount: number;
    openedCount: number;
    submittedCount: number;
    excludedCount: number;
    evaluableCount: number;
    evaluatedCount: number;
    progress: number;
    isDraft: boolean;
    assigneeIds: Array<string>;
}

export interface InternalAssessmentGroupRowTableModel extends InternalAssessmentGroupRow {
    questionnaireName: string;
    responsibleName: string;
    sentString: string;
    deadlineString: string;
    evaluationString: string;
}

export interface InternalAssessmentGroupSaveModel {
    name: string;
    description?: string;
    questionnaireId?: string;
    questionnaireName?: string;
    responsibleId?: string;
    deadline?: Date;
    groupEntityId?: string;
    relations: Array<RelationSaveModel>;
}

export interface InternalAssessmentGroupDraft {
    assigneeId: string;
    assigneeType: AssigneeType;
}

// The fields both group pages need for their top bar row and their page header, so both shared components have
// one type to accept.
export interface InternalAssessmentGroupHeaderModel {
    id: string;
    name: string;
    description?: string;
    sent?: Date;
    deadline: Date;
    assessmentTemplate: string;
    assessmentTemplateId: string;
    responsible: string;
    responsibleId: string;
    sender?: string;
    senderId?: string;
}

export interface InternalAssessmentGroupDraftOverviewModel extends InternalAssessmentGroupHeaderModel {
    isDeadlineOverdue: boolean;
    selectedAssignees: Array<InternalAssessmentGroupDraft>;
    rows: Array<SelectableAssignee>;
}

export enum InternalAssessmentGroupTabs {
    Assessments = 1,
    Tasks = 2,
}

export enum InternalAssessmentGroupPlanTabId {
    Assessments = "assessments",
    Tasks = "tasks",
}

export interface InternalAssessmentGroupOverviewModel extends InternalAssessmentGroupHeaderModel {
    numberOfAssignees: number;
    openedCount: number;
    submittedCount: number;
    excludedCount: number;
    progress: number;
    scoreEnabled: boolean;
    overallRiskLevel?: RiskLevel;
    overallRiskLevelName?: string;
    overallRiskScore?: number;
    canBeDeleted: boolean;
    assessments: InternalAssessmentApiModel;
}
